/* eslint-disable react/prop-types */
import React from "react";
import { Typography, Box, makeStyles } from "@material-ui/core";
import { FaUser, FaRegCalendarAlt } from "react-icons/fa";
import { AiOutlineComment } from "react-icons/ai";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.box,
    padding: 0,
    height: "125px",
    display: "flex",
    flexDirection: "column",
  },
  scenarioContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: theme.box.padding,
    height: "100%",
  },
  section: {
    padding: "5px",
  },
  scenarioName: {
    ...theme.uncontrolledText,
    textAlign: "center",
    fontWeight: "bold",
  },
  bodyContainer: {
    // paddingBottom: "10px",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    paddingTop: 0,
    justifyContent: "space-around",
    "& p": {
      lineHeight: "normal",
      wordSpacing: "0px",
    },
  },
  bodyItem: {
    display: "flex",
    alignItems: "center",
    color: theme.palette.text.ternary,
    "& p": {
      wordBreak: "break-all",
      overflow: "hidden",
      display: "-webkit-box",
      "-webkit-line-clamp": 1,
      "-webkit-box-orient": "vertical",
    },
  },
  footer: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
    borderTop: theme.box.border,
  },
  iconContainer: {
    display: "flex",
    alignItems: "inherit",
    marginRight: "7px",
  },
}));

const ScenarioSummaryCard = ({
  scenario,
  header: HeaderComponent,
  body: BodyComponent,
  showScenarioName = true,
  footerStyles = {},
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      {HeaderComponent}
      <Box className={classes.scenarioContainer}>
        {showScenarioName && (
          <Box className={classes.section}>
            <Typography variant="body2" className={classes.scenarioName}>
              {scenario?.name}
            </Typography>
          </Box>
        )}
        {!BodyComponent ? (
          <Box className={clsx(classes.section, classes.bodyContainer)}>
            <Box className={classes.bodyItem}>
              <Box className={classes.iconContainer}>
                <AiOutlineComment />
              </Box>
              <Typography variant="body2">
                {scenario?.comment || "-"}
              </Typography>
            </Box>
            <Box className={classes.bodyItem}>
              <Box className={classes.iconContainer}>
                <FaRegCalendarAlt />
              </Box>
              <Typography variant="body2">{scenario?.cycle?.label}</Typography>
            </Box>
          </Box>
        ) : (
          BodyComponent
        )}
        <Box
          className={clsx(classes.section, classes.footer)}
          style={footerStyles}
        >
          <Box className={classes.iconContainer}>
            <FaUser />
          </Box>
          <Typography variant="body2" noWrap>
            {scenario?.owner_label}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default ScenarioSummaryCard;
